import { __assign } from "tslib";
import * as React from 'react';
import s from './category-header.scss';
import { dtoToSubCategoriesSelectorProps, SubCategoriesSelector, } from '../sub-categories-selector';
import { Box, Heading, Text } from 'wix-style-react';
import { BackButton } from '../../back-button';
import { composer } from '../../../component-decorators/composer';
export var dtoToCategoryHeaderProps = function (res) {
    var _a, _b, _c, _d, _e, _f;
    var name = (_b = (_a = res === null || res === void 0 ? void 0 : res.tagsAndSubCategories) === null || _a === void 0 ? void 0 : _a[0].tag) === null || _b === void 0 ? void 0 : _b.name;
    var slug = (_d = (_c = res === null || res === void 0 ? void 0 : res.tagsAndSubCategories) === null || _c === void 0 ? void 0 : _c[0].tag) === null || _d === void 0 ? void 0 : _d.slug;
    var description = (_f = (_e = res === null || res === void 0 ? void 0 : res.tagsAndSubCategories) === null || _e === void 0 ? void 0 : _e[0].tag) === null || _f === void 0 ? void 0 : _f.description;
    var subCategoriesSelectorProps = dtoToSubCategoriesSelectorProps(res);
    return {
        slug: slug,
        name: name,
        description: description,
        subCategoriesSelectorProps: subCategoriesSelectorProps,
    };
};
export var CategoryHeader = composer().compose(function (_a) {
    var name = _a.name, description = _a.description, slug = _a.slug, subCategoriesSelectorProps = _a.subCategoriesSelectorProps, shouldShowBackButton = _a.shouldShowBackButton;
    return (React.createElement(Box, { dataHook: 'category-header', paddingBottom: '42px', textAlign: "left", width: "100%", paddingTop: shouldShowBackButton ? '24px' : '36px', direction: 'vertical' },
        shouldShowBackButton && React.createElement(BackButton, { skinColor: 'light' }),
        React.createElement(Heading, { className: s.categoryHeaderName, appearance: 'H1', light: true, dataHook: 'category-header-name' }, name),
        React.createElement(Text, { className: s.categoryHeaderDescription, light: true, tagName: "p", dataHook: 'category-header-description' }, description),
        React.createElement(SubCategoriesSelector, __assign({}, subCategoriesSelectorProps, { categorySlug: slug }))));
});
//# sourceMappingURL=category-header.js.map